import axios from "axios";

let rzpPromise = null;

export const loadRazorpayScript = () => {
  if (!rzpPromise) {
    rzpPromise = new Promise((resolve) => {
      const s = document.createElement("script");
      s.src = "https://checkout.razorpay.com/v1/checkout.js";
      s.onload = () => resolve(true);
      s.onerror = () => {
        rzpPromise = null;
        resolve(false);
      };
      document.body.appendChild(s);
    });
  }
  return rzpPromise;
};

// Opens Razorpay Standard Checkout for an existing payment txnid.
// Order is created server-side (amount from DB, paise); signature verified server-side before marking paid.
export const openRazorpayCheckout = async ({ API, txnid, onPaid, onError }) => {
  const ok = await loadRazorpayScript();
  if (!ok) {
    onError("Could not load the Razorpay checkout — check your connection and try again.");
    return;
  }
  try {
    const { data: o } = await axios.post(`${API}/api/payments/razorpay/order`, { txnid });
    const rzp = new window.Razorpay({
      key: o.key_id,
      amount: o.amount,
      currency: o.currency,
      order_id: o.order_id,
      name: "NexSecure Technologies",
      description: o.product,
      prefill: { name: o.name, email: o.email, contact: o.phone },
      theme: { color: "#0A1628" },
      modal: { ondismiss: () => onError("Payment cancelled — you can try again anytime.") },
      handler: async (resp) => {
        try {
          await axios.post(`${API}/api/payments/razorpay/verify`, {
            txnid,
            razorpay_order_id: resp.razorpay_order_id,
            razorpay_payment_id: resp.razorpay_payment_id,
            razorpay_signature: resp.razorpay_signature,
          });
          onPaid();
        } catch (e) {
          onError(e.response?.data?.detail || "Payment verification failed — please contact us with your reference.");
        }
      },
    });
    rzp.on("payment.failed", (resp) => onError(resp?.error?.description || "Payment failed — please try another method."));
    rzp.open();
  } catch (e) {
    onError(e.response?.data?.detail || "Could not start the Razorpay payment. Please try again.");
  }
};
